<template>
  <component
    :is="tag"
    @click.native="hideSidebar"
    v-bind="$attrs"
    :class="{ sider_li: true }"
    tag="li"
  >
    <slot>
      <a class="sider_links" v-bind="$attrs">
        <i v-if="link.icon" :class="link.icon"></i>
        <p>{{ link.name }}</p>
      </a>
    </slot>
  </component>
</template>
<script>
export default {
  inheritAttrs: false,
  inject: {
    autoClose: {
      default: true,
    },
  },
  props: {
    link: {
      type: [String, Object],
      default: () => {
        return {
          name: "",
          path: "",
          icon: "",
        };
      },
    },
    tag: {
      type: String,
      default: "router-link",
    },
  },
  methods: {
    hideSidebar() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
<style>
.sider_li {
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 10px;
}

.sider_li:hover {
  background: #edf2ff;
}
.sider_li:hover .footer_bot_btn {
  background: #fff !important;
}
.sider_li .website_link:hover {
  color: #3056d3;
}

.sider_li:hover .dasboard_svg {
  fill: #3056d3;
}
.sider_li.active {
  background: #edf2ff;
}
</style>
